import React, { FC, useState } from "react";
import "./IconGallery.scss";
import { BvIcon } from "bevi-icon";
import { useForm } from "react-hook-form";
import { icons } from "../../enums/Icons";

interface IconGalleryProps {
  handleSelect: (icon: string, name: string) => void;
}

interface InputIconGallery {
  search?: string;
}

type Icon = {
  icon: string;
  name: string;
};

const IconGallery: FC<IconGalleryProps> = ({ handleSelect }) => {
  const [filterIcons, setFilterIcons] = useState<Icon[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { register } = useForm<InputIconGallery>();

  const handleSelectClick = (icon: string, name: string) => {
    handleSelect(icon, name);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchTerm(searchValue);

    const filtered = icons.items.filter(
      (i) =>
        i.icon.toLowerCase().includes(searchValue) ||
        i.name.toLowerCase().includes(searchValue)
    );

    setFilterIcons(filtered);
  };

  return (
    <div className="IconGallery" data-testid="IconGallery">
      <div className="col-auto">
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Pesquisar"
            {...register("search")}
            onChange={handleSearch}
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12 d-flex flex-wrap">
          {filterIcons.length > 0 ? (
            filterIcons.map((item, key) => {
              return (
                <div
                  className="card d-flex justify-content-center align-items-center m-1"
                  onClick={() => handleSelectClick(item.icon, item.name)}
                >
                  <BvIcon
                    key={key}
                    name={item.icon}
                    variant="solid"
                    className="mt-2"
                    size={3}
                    title={item.name}
                  />
                  <div className="card-body">
                    <p className="card-text small text-center">{item.name}</p>
                  </div>
                </div>
              );
            })
          ) : searchTerm ? (
            <div className="col col-md-12 d-flex justify-content-center">
              Nenhum ícone encontrado
            </div>
          ) : (
            icons.items.map((item, key) => {
              return (
                <div
                  className="card cursor-pointer d-flex justify-content-center align-items-center m-1"
                  onClick={() => handleSelectClick(item.icon, item.name)}
                >
                  <BvIcon
                    key={key}
                    name={item.icon}
                    variant="solid"
                    className="mt-2"
                    size={3}
                    title={item.name}
                  />
                  <div className="card-body">
                    <p className="card-text small text-center">{item.name}</p>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default IconGallery;
